export default __webpack_public_path__ + "static/media/map-pin-the-fork.9cf20cfe.svg";